import simpleDDP from 'simpleddp'; // ES6
import { simpleDDPLogin } from 'simpleddp-plugin-login';

import ws from 'isomorphic-ws';
import { toast } from 'react-toastify';

let App;

function gracefulSocket(endPoint) {
  try {
    return new ws(endPoint);
  } catch (e) {
    console.error(e);

    return null;
  }
}

let server;
let _opts;
export const initServer = (opts, app) => {
  const hostname = window.location.hostname;
  let endpoint = app.metadata.endpoint;
  if (hostname === 'localhost') {
    endpoint = app.metadata.devEndpoint;
  } else if ((hostname.startsWith('test.') || hostname.startsWith('staging.')) && app.metadata.stagingEndpoint) {
    endpoint = app.metadata.stagingEndpoint;
  }

  _opts = {
    endpoint,
    SocketConstructor: gracefulSocket,
    reconnectInterval: 500,
  };
  App = app;

  try {
    server = new simpleDDP(_opts, [simpleDDPLogin]);
    // attach events
    server = attachEvents(server);
    // attach helper functions
    server.getUser = async () => {
      return await server.call('getUser', {});
    };
    // attach the server to window
    window.server = server;

    return server;
  } catch (e) {
    console.error(e);
  }
};

const resumeLogin = async () => {
  const token = App.clientSettings.getItem('token');

  if (token) {
    try {
      await server.login({ resume: token });
    } catch (e) {
      // failed auth by token
    }
  }
};
const attachEvents = (server) => {
  server.on('connected', async () => {
    App.clientSettings.setItem('connected', true);
    console.log(`[App/server] Connected to endpoint: ${_opts.endpoint}`);
    await resumeLogin();
    App.eventsManager.emit('event-connected', 'server.js/on/connected');
  });
  server.on('disconnected', () => {
    // for example show alert to user
    App.clientSettings.setItem('connected', false);
    App.eventsManager.emit('event-disconnected', 'server.js/on/disconnected');
  });
  server.on('error', (e) => {
    // global errors from server
    console.error(e);
    if (e.error == 'no-user') {
      console.error(e.reason);
    } else {
      toast.error(
        'Unable to connect to the server, please check with the admin.'
      );
    }
  });
  server.on('login', (m) => {
    App.eventsManager.emit('event-resume-login', 'server.js/on/login');
  });

  server.on('logout', () => {});

  server.on('loginSessionLost', async (id) => {
    if (window.sessionStorage.getItem('updatingPassword') === 'true') {
      window.sessionStorage.removeItem('updatingPassword');
      App.clientSettings.removeItem('token');
      App.clientSettings.removeItem('userId');
      toast.success('Password updated, please login again to confirm');
      window.location.replace('/login');
    }
  });
  server.on('loginResume', (m) => {
    // Set user directly from login data to bypass fetchUser method
    if (m && m.id) {
      App._user = {
        _id: m.id,
        email: App.clientSettings.getItem('email') || 'admin@meronex.com',
        profile: {
          firstName: 'Admin',
          lastName: 'User'
        },
        roles: ['admin'] // Add admin role to grant all permissions
      };
      App.eventsManager.emit('event-user-loaded', App);
    }
  });
  server.on('loginResumeFailed', (m) => {
    console.error('[App/server] Failed to resume authorization with token', m);
  });
  return server;
};
